import { signal } from "../net/signal";
import { httpUrl } from "../net/config";
import { games, type Game } from "./games";

/**
 * در دسترس‌بودنِ بازی‌ها — جدا از خودِ کاتالوگ.
 *
 * `games.ts` را سازنده‌ی سایتِ ایستا با نودِ خالی و بی‌باندلر import می‌کند، پس
 * باید فقط داده باشد و هیچ ایمپورتِ مرورگری نداشته باشد. این‌جا کدِ زمانِ
 * اجراست و فقط اپِ وب می‌خواندش.
 */

/**
 * کدام بازی‌ها ادمین خاموششان کرده.
 *
 * فهرستِ بالا در بیلد ثابت است؛ این یکی از `/v1/live` می‌آید و همان لحظه عوض
 * می‌شود. سیگنال است و نه یک `await` سرِ راهِ رندر: لابی نباید منتظرِ شبکه
 * بماند — تا رسیدنِ پاسخ همه‌چیز روشن فرض می‌شود و اگر چیزی خاموش بود، یک
 * لحظه بعد از فهرست می‌رود. برعکسش بدتر بود: لابیِ خالی تا رسیدنِ شبکه.
 */
const offSite = signal<Set<string>>(new Set());
const offOnline = signal<Set<string>>(new Set());

/**
 * بازی‌هایی که همین حالا روی قفسه‌اند.
 *
 * فقط خاموشیِ **سایت** بازی را از قفسه برمی‌دارد. خاموشیِ **آنلاین** یعنی
 * «بی چندنفره» و نه «بی بازی»: بازی می‌مانَد و انتخابش مستقیم میزی با ربات‌ها
 * می‌سازد. بی این، بازی‌ای که از آنلاین درمی‌آمد کلاً ناپدید می‌شد.
 */
export function liveGames(offS: Set<string>, _offO: Set<string>): Game[] {
  return games.filter((g) => !offS.has(g.id));
}

/** این بازی چندنفره دارد؟ */
export const hasMultiplayer = (offO: Set<string>, id: string) => !offO.has(id);

export { offSite, offOnline };

/**
 * یک‌بار سرِ بالا آمدن می‌پرسد و بس.
 *
 * خاموش‌کردنِ بازی کارِ نادری است و ارزشِ نظرسنجیِ هر چند ثانیه را ندارد؛ هر
 * تازه‌کردنِ صفحه تازه‌اش می‌کند. خطا بی‌صداست: نرسیدنِ این پاسخ نباید لابی را
 * از کار بیندازد.
 */
export async function loadAvailability(): Promise<void> {
  try {
    const r = await fetch(httpUrl("/v1/live"), { cache: "no-store" });
    if (!r.ok) return;
    const j = (await r.json()) as { games_off_site?: string[]; games_off_online?: string[] };
    offSite.value = new Set(j.games_off_site ?? []);
    offOnline.value = new Set(j.games_off_online ?? []);
  } catch {
    /* شبکه نبود — همه روشن می‌مانند */
  }
}
